// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// noinspection SpellCheckingInspection

export const environment = {
  // production: false,
  production: true,
/*
  firebase: {
    apiKey: 'AIzaSyAcUSsJfAhUrjPNAna3gmg_12itADhasOQ',
    authDomain: 'odl-demo.firebaseapp.com',
    databaseURL: 'https://odl-demo.firebaseio.com',
    projectId: 'odl-demo',
    storageBucket: '',
    messagingSenderId: '1015757428686',
    appId: '1:1015757428686:web:289788fed27f6bf8'
  },
*/



  firebase: {
    apiKey: 'AIzaSyBpGeinHZQxP240-WGTfrnkPdgxrV1vKWA',
    authDomain: 'ordinidilavoro-625e3.firebaseapp.com',
    databaseURL: 'https://ordinidilavoro-625e3.firebaseio.com',
    projectId: 'ordinidilavoro-625e3',
    storageBucket: '',
    messagingSenderId: '1021780668887',
    appId: '1:1021780668887:web:eac6037e8afb30c7025b92'
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
